// extracted by mini-css-extract-plugin
export var layout = "default-module--layout--2mGY2";
export var app = "default-module--app--vje_e";
export var main = "default-module--main--CZn8B";
export var footer = "default-module--footer--24Lxm";